import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { DeliveredSvg, DepotSvg, TransporterSvg, TruckFastSvg } from "../Svgs";

const DeliveryActions = () => {
  const { t } = useTranslation("common");
  const { delivery } = useSelector((state) => state.deliveryReducer);
  const actions = delivery?.attributes?.deliveryActions?.data;

  const text = {
    READY: t("Order preparation by the depot"),
    DELIVERED: t("Delivery made"),
    DELIVERY: t("Delivery in the process of being delivered by the carrier"),
    RECUP: t("Recovery of the goods by the carrier"),
  };

  const nextText = {
    READY: `- ${t("Next step - Recovery by the transporter")}`,
    DELIVERY: `- ${t("Next step - Delivery to store")}`,
    RECUP: `- ${t("Next step - in the process of being delivered")}`,
  };

  const icon = {
    READY: <DepotSvg color="white" />,
    RECUP: <TransporterSvg color="white" />,
    DELIVERY: <TruckFastSvg color="white" />,
    DELIVERED: <DeliveredSvg color="white" />,
  };

  if (!actions?.length > 0) return null;

  return (
    <div>
      <div className="d-flex flex-column my-4 position-relative pt-4 px-4">
        <span className="position-absolute top-0 ms-5 start-22 br5 h-100-25px border border-gray-100 w-6px" />
        {actions?.map((action) => {
          return (
            <div key={action.id} className="position-relative py-4 ps-4 pe-5">
              <div className="d-flex align-items-center gap-4">
                <div
                  className={`position-absolute br5 z-n1 top-0 start-0 w-100 h-100`}
                ></div>
                <span
                  className={`d-flex align-items-center justify-content-center text-white rounded-circle size-50px f20 align-middle ${
                    action?.attributes?.status === "DELIVERED"
                      ? "bg-green-500"
                      : "bg-blue-500"
                  }`}
                >
                  {icon[action?.attributes?.status]}
                </span>
                <div className="d-flex flex-column">
                  <p className="f13 text-ultraBlack mb-0 medium">
                    {text[action?.attributes?.status]}
                  </p>
                  <p className="f13 text-ultraBlack mb-0 medium">
                    <span className="">
                      <span className="bold">{`${moment().format(
                        "DD/MM/YYYY"
                      )} `}</span>
                      {nextText[action?.attributes?.status] ?? ""}
                    </span>
                  </p>
                  <p className="f13 text-ultraBlack mb-0 medium"></p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DeliveryActions;
